import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Heart, TrendingUp } from 'lucide-react';
const benefits = [{
  title: 'Tranquilidad Mental',
  description: 'Dormí tranquilo sabiendo que tenés el control total de tu situación financiera.',
  icon: Heart,
  color: 'bg-rose-50 text-rose-600'
}, {
  title: 'Ahorro Real',
  description: 'Identificá gastos hormiga y empezá a guardar plata para lo que realmente importa.',
  icon: TrendingUp,
  color: 'bg-teal-50 text-teal-600'
}, {
  title: 'Sin Complicaciones',
  description: 'No necesitás ser experto. La plantilla hace los cálculos difíciles por vos.',
  icon: Zap,
  color: 'bg-amber-50 text-amber-600'
}, {
  title: 'Seguridad Total',
  description: 'Tus datos son tuyos. No vinculás cuentas bancarias ni compartís contraseñas.',
  icon: ShieldCheck,
  color: 'bg-blue-50 text-blue-600'
}];
export function Benefits() {
  return <section className="py-10 md:py-20 bg-gray-50" data-id="element-15">
      <div className="container mx-auto px-4 md:px-6" data-id="element-16">
        <div className="text-center mb-6 md:mb-12" data-id="element-17">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-18">
            Más que una planilla, un cambio de vida
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-19">
            Los beneficios de ordenar tus finanzas van mucho más allá de los
            números.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-20">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-3 md:p-6 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow" data-id="element-21">
              <div className={`w-8 h-8 md:w-12 md:h-12 ${benefit.color} rounded-xl flex items-center justify-center mb-2 md:mb-4`} data-id="element-22">
                <benefit.icon className="w-4 h-4 md:w-6 md:h-6" data-id="element-23" />
              </div>
              <h3 className="text-sm md:text-lg font-bold text-gray-900 mb-1 md:mb-2" data-id="element-24">
                {benefit.title}
              </h3>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed" data-id="element-25">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}